module.exports = __webpack_public_path__ + "img/ez-slot-category-fishing-game-mobile.2fb78c2d.png";